<template>
    <card 
        v-if="!finished"
        shadow
        class="col-8 col-sm-3 col-lg-3 border-0"
        style="margin-bottom: 0"
        headerClasses="p-1"
        body-classes="p-1"
    >
        <template #header>
            <div class="d-flex align-items-center" :class="`justify-content-${started ? 'between' : 'center'}`">
                <div class="d-flex flex-column text-center">
                    <span>{{ started ? $t('exercise.time.remaining') : $t('exercise.time.limit') }}:</span>
                </div>
                <i v-if="started" :style="{ color: color.primary }" class="mdi mdi-36px mdi-timer-sand-full"></i>
            </div>
        </template>
        <div class="d-flex row justify-content-center align-items-center">
            <h2 v-if="started" class="mb-0" :style="{ color: color.primary }">
                {{ $moment("2015-01-01").startOf('day').seconds(studentTime).format('HH:mm:ss') }}
            </h2>
            <base-button v-else class="mt-3" :style="$bgColor(color.primary)" @click="startExercise">{{$t('common.start')}}</base-button>
        </div>
    </card>
</template>

<script>
import Card from '../../argon/components/Cards/Card'
import BaseButton from '../../argon/components/BaseButton'

export default {
    name: 'ExerciseTimer',
    components: {
        Card,
        BaseButton
    },
    data() {
        return {
            submitted: false,
            timerRunning: false,
        }
    },
    computed: {
        color() {
            return this.$store.getters.COLOR
        },
        studentTime() {
            return this.$store.getters.LOADED_EXERCISE.student_time
        },
        exerciseId() {
            return this.$store.getters.LOADED_EXERCISE.id
        },
        started() {
            return this.$store.getters.LOADED_EXERCISE.started
        },
        finished() {
            return this.$store.getters.LOADED_EXERCISE.finished
        }
    },
    watch: {
        started(val) {
            if (val) return this.startTimer()
        }
    },
    methods: {
        decrement(delay) {
            return new Promise((resolve) => {
                setTimeout(resolve, delay)
            })
        },
        async startTimer() {
            if (this.timerRunning) return
            this.timerRunning = true

            const timer = this.studentTime

            for (let i = 0; i <= timer; i++) {

                const val = this.studentTime - 1
                await this.$store.commit('SET_EXERCISE_STUDENT_TIME', val)

                await this.decrement(1000)
                
                if (this.studentTime === 0) {
                    await this.submitAfterTimeout()
                    break
                }
                
                if (!this.studentTime) break

                if (!this.started) break
            }
        },
        async submitAfterTimeout() {
            if (!this.exerciseId || this.submitted) return
            this.submitted = true
            this.$loading.show()
            await this.$store.dispatch('SUBMIT_EXERCISE', { id: this.exerciseId, forced: true })
            this.$loading.close()
        },
        async startExercise() {
            await this.$store.dispatch('GET_EXERCISE_STUDENT_TIME')
        }
    }
}
</script>

<style scoped>
</style>